type PictureProps = {
  webp: string;
  src: string;
  alt: string;
  className?: string;
};

export default function Picture({ webp, src, alt, className }: PictureProps) {
  return (
    <picture>
      <source srcSet={webp} type="image/webp" />
      <img src={src} alt={alt} className={className} />
    </picture>
  );
}
